import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => (
  <Dialog open={open} onClose={onCancel} data-testid="confirm-dialog">
    <DialogTitle data-testid="confirm-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText data-testid="confirm-dialog-message">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} data-testid="confirm-dialog-cancel">
        {cancelText}
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        data-testid="confirm-dialog-confirm"
      >
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
